import { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, Label, FormGroup, Row, Col, Input } from 'reactstrap';
import { connect } from 'react-redux';
import { map, some } from 'lodash';
import PropTypes from 'prop-types';

import DatePicker, { registerLocale } from 'react-datepicker';
import NumberFormat from 'react-currency-format';
import Select from 'react-select';
import es from 'date-fns/locale/es';

import { getSexes, getNationalities, getCivilStatus, getRegions, getCommuns } from '../../../redux/actions/resourcesActions';
import { ROLES, optionsTypes } from '../../../helper/constants';
import { isRUTValid, validateEmail } from '../../../helper/functions';

import ContactModalAdressesForm from './ContactModalAdresessForm';
import ContactModalPhonesForm from './ContactModalPhonesForm';
import { isUserAllowed } from '../../../shared/utils';

registerLocale('es', es);

const initialModalValues = {
  regions: null
}

const lastYear = new Date();
lastYear.setFullYear(lastYear.getFullYear() - 1);

const ContactModal = (props) => {
  const { toggle, isOpen, getSexes, getNationalities, getCivilStatus, getRegions, onChangeInput, onSubmit, value } = props;

  const sexes = map(props.sexes, typ => ({ value: typ.value, label: typ.label }));
  const nationalities = map(props.nationalities, typ => ({ value: typ.value, label: typ.label }));
  const civilStatus = map(props.civilStatus, typ => ({ value: typ.value, label: typ.label }));

  const [modalData, setModalData] = useState(initialModalValues);

  useEffect(() => { getSexes() }, [getSexes]);
  useEffect(() => { getNationalities() }, [getNationalities]);
  useEffect(() => { getCivilStatus() }, [getCivilStatus]);
  useEffect(() => {
    getRegions({ all: true }, (body) => {
      setModalData(data => ({ ...data, regions: body }));
    })
  }, [getRegions]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} className='cmr-contact-modal-container'>
      <div className='crm-contact-modal-header'>
        <button type="button" className="lnr lnr-cross modal__close-btn" onClick={toggle} />
        <div><strong>Nuevo Contacto</strong></div>
      </div>
      <form id='added' onSubmit={onSubmit}>
        <ModalBody>
          <Row>
            <Col md="12" className="mb-3">
              <h4 className="title_modal_contact"> Datos personales </h4>
            </Col>
            <Col md="4">
              <FormGroup>
                <Label className="label_autofin" for="type">Tipo:</Label>
                <Select
                  options={optionsTypes}
                  type="text"
                  name="type"
                  id="type"
                  placeholder="seleccionar"
                  value={value.type}
                  onChange={onChangeInput('type')}
                  isDisabled={isUserAllowed(ROLES.auditor)}
                  required
                />
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <Label className="label_autofin" for="rut">*Rut:</Label>
                <Input
                  type="text"
                  name="rut"
                  id="rut"
                  value={value.rut}
                  onChange={onChangeInput('rut')}
                  invalid={!isRUTValid(value.rut)}
                  disabled={value._id || isUserAllowed(ROLES.auditor)}
                  required
                />
              </FormGroup>
            </Col>
            {(value.type.value !== 'company') && <Col md="4">
              <FormGroup>
                <Label className="label_autofin" for="names">*Nombres:</Label>
                <Input
                  type="text"
                  name="names"
                  id="names"
                  maxLength="20"
                  value={value.names}
                  onChange={onChangeInput('names')}
                  disabled={isUserAllowed(ROLES.auditor)}
                  required
                />
              </FormGroup>
            </Col>}
            {(value.type.value !== 'company') &&
              <Col md="4" >
                <FormGroup>
                  <Label className="label_autofin" for="paternalSurname">*Apellido Paterno:</Label>
                  <Input
                    type="text"
                    name="paternalSurname"
                    id="paternalSurname"
                    maxLength="20"
                    value={value.paternalSurname}
                    onChange={onChangeInput('paternalSurname')}
                    disabled={isUserAllowed(ROLES.auditor)}
                    required
                  />
                </FormGroup>
              </Col>}
            {(value.type.value !== 'company') &&
              <Col md="4" >
                <FormGroup>
                  <Label className="label_autofin" for="maternalSurname2">Apellido Materno:</Label>
                  <Input
                    type="text"
                    name="maternalSurname2"
                    id="maternalSurname2"
                    maxLength="20"
                    value={value.maternalSurname}
                    onChange={onChangeInput('maternalSurname')}
                    autoComplete="off"
                    disabled={isUserAllowed(ROLES.auditor)}
                    required
                  />
                </FormGroup>
              </Col>}
            {(value.type.value === 'company') &&
              <Col md="4" >
                <FormGroup>
                  <Label className="label_autofin" for="companyName">*Nombre empresa:</Label>
                  <Input
                    type="text"
                    name="companyName"
                    id="companyName"
                    maxLength="20"
                    value={value.companyName}
                    onChange={onChangeInput('companyName')}
                    disabled={isUserAllowed(ROLES.auditor)}
                    required
                  />
                </FormGroup>
              </Col>}
            {(value.type.value === 'company') &&
              <Col md="4">
                <FormGroup>
                  <Label className="label_autofin" for="userSII">*Usuario SII:</Label>
                  <Input
                    type="text"
                    name="userSII"
                    id="userSII"
                    maxLength="20"
                    value={value.userSII}
                    onChange={onChangeInput('userSII')}
                    disabled={isUserAllowed(ROLES.auditor)}
                    required
                  />
                </FormGroup>
              </Col>}
            {(value.type.value === 'company') &&
              <Col md="4" >
                <FormGroup>
                  <Label className="label_autofin" for="password">*Contraseña:</Label>
                  <Input
                    type="password"
                    name="password"
                    id="password"
                    maxLength="20"
                    value={value.passwordSII}
                    onChange={onChangeInput('passwordSII')}
                    disabled={isUserAllowed(ROLES.auditor)}
                    required
                  />
                </FormGroup>
              </Col>}
            {value.type.value !== 'company' &&
              <Col md="4">
                <FormGroup className="columend_date">
                  <Label className="label_autofin" for="birthdate">Fecha de nacimiento:</Label>
                  <DatePicker
                    className="form-control"
                    locale="es"
                    dateFormat="dd/MM/yyyy"
                    name="birthdate"
                    id="birthdate"
                    maxDate={lastYear}
                    showYearDropdown
                    dropdownMode="select"
                    selected={value.birthdate}
                    onChange={onChangeInput('birthdate')}
                    customInput={<Input />}
                    disabled={isUserAllowed(ROLES.auditor)}
                    required
                  />
                </FormGroup>
              </Col>}
            <Col md="4">
              <FormGroup>
                <Label className="label_autofin" for="rent">Renta:</Label>
                <NumberFormat
                  prefix="$"
                  min="0"
                  name="rent"
                  id="rent"
                  max="99999999"
                  decimalSeparator=","
                  thousandSeparator="."
                  value={value.rent || ''}
                  onChange={onChangeInput('rent')}
                  maxLength={12}
                  disabled={isUserAllowed(ROLES.auditor)}
                  required
                />
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <Label className="label_autofin" for="nationality">Nacionalidad:</Label>
                <Select
                  options={nationalities}
                  type="text"
                  name="nationality"
                  id="nationality"
                  placeholder="seleccionar"
                  value={value.nationality}
                  onChange={onChangeInput('nationality')}
                  isDisabled={isUserAllowed(ROLES.auditor)}
                  required
                />
              </FormGroup>
            </Col>
            {value.type.value !== 'company' &&
              <Col md="4" >
                <FormGroup>
                  <Label className="label_autofin" for="sex">Sexo:</Label>
                  <Select
                    options={sexes}
                    type="text"
                    name="sex"
                    id="sex"
                    isClearable="true"
                    placeholder="seleccionar"
                    value={value.sex}
                    onChange={onChangeInput('sex')}
                    isDisabled={isUserAllowed(ROLES.auditor)}
                    required
                  />
                </FormGroup>
              </Col>}
            {value.type.value !== 'company' &&
              <Col md="4">
                <FormGroup>
                  <Label className="label_autofin" for="civilStatus">Estado civil:</Label>
                  <Select
                    options={civilStatus}
                    type="text"
                    placeholder="seleccionar"
                    name="civilStatus"
                    isClearable="true"
                    id="civilStatus"
                    value={value.civilStatus}
                    isDisabled={isUserAllowed(ROLES.auditor)}
                    onChange={onChangeInput('civilStatus')}
                    required
                  />
                </FormGroup>
              </Col>}
            <Col md="12" className="mb-4 crm-contact-modal-data-title">
              <Row>
                <Col md="4">
                  <h4 className="title_modal_contact"> Direcciones </h4>
                  {!isUserAllowed(ROLES.auditor) && <button className="plus_add" onClick={props.addAddress} size="sm">+</button>}
                </Col>
              </Row>
            </Col>
            <Col sm="12">
              {map(value.addresses, (address, index) => (
                <ContactModalAdressesForm
                  onChangeAddress={props.onChangeAddress}
                  onRemoveAddress={props.onRemoveAddress}
                  modalData={modalData}
                  address={address}
                  index={index}
                />
              ))}
            </Col>
            <Col md="12" className="mb-4 crm-contact-modal-data-title">
              <Row>
                <Col md="4">
                  <h4 className="title_modal_contact"> Teléfono </h4>
                  {!isUserAllowed(ROLES.auditor) && <button className="plus_add" onClick={props.addPhone} color="success" size="sm">+</button>}
                </Col>
              </Row>
            </Col>
            <Col sm="12">
              {map(value.phones, (phone, index) => (
                <ContactModalPhonesForm
                  onChangePhone={props.onChangePhone}
                  onRemove={props.onRemove}
                  phone={phone}
                  index={index}
                />
              ))}
            </Col>
            <Col md="12" className="mb-4 crm-contact-modal-data-title">
              <Row>
                <Col md="4">
                  <h4 className="title_modal_contact"> Correo </h4>
                  {!isUserAllowed(ROLES.auditor) && <button className="plus_add" onClick={props.addEmail} color="success" size="sm">+</button>}
                </Col>
              </Row>
            </Col>
            <Col sm="12">
              {map(value.emails, (email, index) => (
                <Row key={index} className="mt-6 crm-contact-modal-forms-container">
                  <Col sm="4">
                    <FormGroup>
                      <Label className="label_autofin" for="profile">Correos Electrónicos</Label>
                      <Input
                        className="mb-2"
                        maxLength="50"
                        onChange={props.onChangeEmail('email', index)}
                        value={email.email}
                        type="email"
                        placeholder="Email"
                        required
                        invalid={!validateEmail(email.email)}
                        disabled={isUserAllowed(ROLES.auditor)}
                      />
                    </FormGroup>
                  </Col>
                  {!isUserAllowed(ROLES.auditor) && <Col sm="1" className="mt-4">
                    <button className="mb-2 plus_add2" onClick={props.onRemoveEmail(index)} size="sm">
                      <span className="lnr lnr-lnr lnr-trash" style={{ fontWeight: 'bold', cursor: 'pointer' }} />
                    </button>
                  </Col>}
                </Row>
              ))}
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button className="asignar" onClick={toggle}>Cancelar</Button>
          {!isUserAllowed(ROLES.auditor) &&
            <Button className="asignar just_this" type="submit" id="added" disabled={props.disableButtonCreate || some(value.emails, (e) => !validateEmail(e.email))}>
              Guardar
            </Button>
          }
        </ModalFooter>
      </form>
    </Modal >
  );
}

ContactModal.propTypes = {
  getNationalities: PropTypes.func,
  onChangeAddress: PropTypes.func,
  onRemoveAddress: PropTypes.func,
  getCivilStatus: PropTypes.func,
  onChangeInput: PropTypes.func,
  onChangeEmail: PropTypes.func,
  onRemoveEmail: PropTypes.func,
  onChangePhone: PropTypes.func,
  getRegions: PropTypes.func,
  addAddress: PropTypes.func,
  getSexes: PropTypes.func,
  onSubmit: PropTypes.func,
  addPhone: PropTypes.func,
  onRemove: PropTypes.func,
  addEmail: PropTypes.func,
  toggle: PropTypes.func,
  value: PropTypes.string,
  isOpen: PropTypes.bool,
  disableButtonCreate: PropTypes.bool,
  sexes: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  nationalities: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  civilStatus: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
};

const mapStateToProps = ({ resources }) => ({
  nationalities: resources.nationalities,
  civilStatus: resources.civilStatus,
  regions: resources.Regions,
  Communs: resources.Communs,
  sexes: resources.sexes,
});

const mapDispatchToProps = {
  getNationalities,
  getCivilStatus,
  getCommuns,
  getRegions,
  getSexes,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactModal);